import { APIClient } from 'infra/APIClient'
import { APIConfig } from 'types/definitions'

export interface FreshbooksAPI {
  freshbooksHubspot: FreshbooksHubspotAPI
}

export function createFreshbooksAPI(opts: APIConfig): FreshbooksAPI {
  return {
    freshbooksHubspot: new FreshbooksHubspotAPI(opts),
  }
}

export class FreshbooksHubspotAPI extends APIClient {
  getToken(): Promise<string> {
    return this.client.get('/hubspot-tracking').then((res) => res.data.token)
  }
}
